import { useEffect, useRef } from "react";
import type { CityOrderReview } from "../../../api/cityOrders";
import { formatMoney, fromCents } from "../../../api/money";
import { differences, totalAfterCents, type Choices } from "./cityOrderReview";

/** Step 4: what confirming does. Focus moves to its heading on arrival, so a
 * second press of Enter on "Continue" cannot land on "Confirm". */
export default function ConfirmStep({ review, choices }: { review: CityOrderReview; choices: Choices }) {
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    heading.current?.focus();
  }, []);
  const used = differences(review).filter((line) => choices[line.code]?.keep === "city");
  const kept = differences(review).filter((line) => choices[line.code]?.keep === "ours");
  const boq = review.boq?.name ?? "the BOQ";
  const approving = review.boq?.status === "approved" ? `and leaves ${boq} approved` : `and approves ${boq}`;
  return (
    <>
      <h3 ref={heading} tabIndex={-1}>
        Confirm PO {review.order.number}
      </h3>
      {used.length > 0 ? (
        <>
          <h4>Changes to {boq}</h4>
          <ul>
            {used.map((line) => (
              <li key={line.code}>{line.message}</li>
            ))}
          </ul>
        </>
      ) : null}
      {kept.length > 0 ? (
        <>
          <h4>Kept as ours</h4>
          <ul>
            {kept.map((line) => (
              <li key={line.code}>
                {line.code}: {choices[line.code].reason.trim()}
              </li>
            ))}
          </ul>
        </>
      ) : null}
      <p className="cm-doc-note">
        Our BOQ: {formatMoney(fromCents(totalAfterCents(review, choices)))} · The City's PO: {formatMoney(review.totals.city_excl_vat)}
      </p>
      <p>
        <strong>
          This validates PO {review.order.number} {approving}.
        </strong>
      </p>
    </>
  );
}
